var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgCatalog = function SvgCatalog(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2Zm2.078 4.468 2.278 1.76-.024.05-2.863-1.016.61-.794Zm-3.432.48c.921.328 1.824.65 2.727.97l-.001.046h-3.085l.36-1.015Zm4.155 9.894h-8.14V8.64h8.14v8.204Zm.668-1.576v-6.6l2.125.754-2.086 5.853-.039-.007Zm.782.188-.043-.023 2-5.774 1.582 1.221-3.54 4.576Z",
    fill: "currentColor"
  })));
};
export default SvgCatalog;